import { Schema, SchemaSettings } from '@orbit/data'
import { KC } from '@/http/utils'
import { DataPoint } from '@/jsonapi/CommonTypes'

enum ModelTypes {
  PatientWithActigraphyReports = 'patient-with-actigraphy-report',
}

enum ModelTypeNames {
  PatientWithActigraphyReports = 'patientWithActigraphyReport',
}

export interface PatientWithActigraphyReportsAttributes {
  id: string
  firstName: string | null
  lastName: string | null
  timezone: string | null
  patientId: string | null
  starttimestamp: number | null
  endtimestamp: number | null
  resultStartTimestamp: number | null
  resultEndTimestamp: number | null

  activityCounts: DataPoint[]
  sleepStates: DataPoint[]
}

export interface PatientWithActigraphyReportsSchema {
  id: string
  attributes: PatientWithActigraphyReportsAttributes
}

export interface GetPatientWithActigraphyReportsByIdDto {
  patientId: string
  startTimestamp: number
  endTimestamp: number
}

const schemaDefinition: SchemaSettings = {
  models: {
    [ModelTypeNames.PatientWithActigraphyReports]: {
      attributes: {
        id: { type: 'string' },
        firstName: { type: 'string' },
        lastName: { type: 'string' },
        timezone: { type: 'string' },
        patientId: { type: 'string' },
        starttimestamp: { type: 'number' },
        endtimestamp: { type: 'number' },
        resultStartTimestamp: { type: 'number' },
        resultEndTimestamp: { type: 'number' },
        activityCounts: { type: 'array' },
        sleepStates: { type: 'array' },
      },
    },
  },
}

export async function getPatientWithActigraphyReportsById(params: GetPatientWithActigraphyReportsByIdDto) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  return remote
    .query(q => {
      console.log('Before calling find record for patient with actigraphy reports', params.patientId)

      return q
        .findRecords(ModelTypes.PatientWithActigraphyReports)
        .filter(
          { attribute: 'id', value: params.patientId },
          { attribute: 'starttimestamp', value: params.startTimestamp },
          { attribute: 'endtimestamp', value: params.endTimestamp }
        )
    })
    .catch(() => {
      console.log('fetch failed in get patient with actigraphy reports ')
    })
}
